import(/* webpackMode: "eager" */ "C:\\Users\\Pedro polo\\Documents\\Programacion\\gtsconsultores-main\\src\\app\\not-found.tsx");
